import { logger } from '@ecosystem/newron-client-lib';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppProps } from 'single-spa';
import singleSpaReact from 'single-spa-react';

import { Root } from './private/Root';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err: Error, info: React.ErrorInfo, props: AppProps) {
    logger.error(err, {
      componentStack: info.componentStack,
    });
    return (
      <div className="mx-32 my-16">
        <feedbackV2.Alert
          title={`An error has occurred within ${props.name}. Please refresh your browser, if the error persists please contact
          support for assistance.`}
          type="error"
        />
      </div>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;

export {
  CollectionInsight,
  CreateInsightDataFn,
  ExportPngInfo,
  InsightInfo,
  InsightExporter,
  InsightRendererProps,
  Proposition,
} from './shared/types';

export { AddInsightToCollectionsButton, AddInsightToCollectionsMenuItem } from './public/AddInsightToCollections';
export { CollectionsInsightRenderRegister } from './public/CollectionsInsightRendererRegister';
export {
  MultiEditRegister,
  MultiEditInsight,
  KnownConfigItemType,
  MultiEditCallbacks,
} from './public/MultiEditRegister';
